module.exports = __webpack_public_path__ + "media/assets/icons/internal users copy-6583dd941c132a96f9fa6a11ad654310.svg";